import { Component, Input } from '@angular/core';
import { ScopeMandatory } from './scope-mandatory.enum';

@Component({
    selector: 'ssf-permissions',
    template: require('./permissions.component.html'),
    styles: [require('./permissions.component.scss')]
})
export class PermissionsComponent {
    public i18n = 'SCOPES.';

    /**
     * see applications\model\application\scopes.model.ts Scopes.mandatory
     */
    @Input() scopes: string[];
    // declare this to make it accessible in the template
    public ScopeMandatory = ScopeMandatory;

    /**
     * Function converts lower and upper case string scopes to ScopeMandatory[]. It also disregards scopes, that
     * aren't known to the frontend.
     *
     * Until fixed: https://a-team.csint.cz/agile-jira/browse/PSD2DEV-278
     *
     * @param {string[]} scopes
     * @return {ScopeMandatory[]}
     */
    public normalize(scopes: string[]): ScopeMandatory[] {
        if (!scopes) {
            return [];
        }

        return scopes
            .map(scope => (scope  &&  scope.length) ? ScopeMandatory[scope.toUpperCase()] : null)
            .filter(scope => !!scope);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/permissions/permissions.component.ts